var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.9492H6.75C6.0625 13.9492 5.5 13.3867 5.5 12.6992C5.5 12.0117 6.0625 11.4492 6.75 11.4492H14.25C14.9375 11.4492 15.5 12.0117 15.5 12.6992C15.5 13.3867 14.9375 13.9492 14.25 13.9492Z",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74955 13.9492L5.62455 16.4492C5.18705 17.3242 5.87455 18.3242 6.87455 18.3242C7.49955 18.3242 8.06205 17.8867 8.24955 17.2617L8.99955 13.9492",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2441 13.9492L15.3691 16.4492C15.8066 17.3242 15.1191 18.3242 14.1191 18.3242C13.4941 18.3242 12.9316 17.8867 12.7441 17.2617L11.9941 13.9492",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.876 2.69922H9.06351C6.25101 2.69922 4.50101 6.13672 6.00101 8.82422L7.43851 11.4492H13.4385L14.876 8.82422C16.4385 6.13672 14.6885 2.69922 11.876 2.69922Z",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 7.07422C11.0625 7.07422 10.5 6.51172 10.5 5.82422C10.5 5.32422 10.8125 4.88672 11.1875 4.69922C11 4.63672 10.75 4.57422 10.5 4.57422C9.4375 4.57422 8.625 5.38672 8.625 6.44922C8.625 7.51172 9.4375 8.32422 10.5 8.32422C11.375 8.32422 12.0625 7.76172 12.3125 6.94922C12.125 7.01172 11.9375 7.07422 11.75 7.07422Z",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsChair);
export default __webpack_public_path__ + "static/media/kidsChair.3000edb9bfdebcbc7782badc28d73523.svg";
export { ForwardRef as ReactComponent };